import axios from 'axios';
import env from '../config/env';
import Storage from '../helpers/storage';

export default (
  endpoint = env.REACT_APP_API_ENDPOINT,
  accessToken = Storage.getLocalStorage('auth').accessToken
) => {
  let headers = { 'Content-Type': 'application/json' };
  if (accessToken) {
    headers = {
      ...headers,
      Authorization: `Bearer ${accessToken}`,
      'Accept-Language': 'pt-BR',
    };
  }

  const instance = axios.create({
    baseURL: endpoint,
    timeout: 30000,
    maxRedirects: 0,
    headers,
  });

  return instance;
};



// WEBPACK FOOTER //
// ./src/services/index.js